import React, { useEffect, useState } from 'react'
import Tools from '../../../Misc/Tools';
import { UIBaseImplementation } from '../../../UI/UIBaseImplementation';
import { UIProperties } from '../UIProperties';
import CoreGeneralButton from './core-general-button';

import "./core-general-question-ui.css"
import { TextHtmlTagType, updateMentorVideo } from '../../../../misc/tools';
import SoundManager from '../../../Sound/SoundManager';
import { GameBaseScenario } from '../../../../scenarios/GameBaseScenario';

export interface GeneralQuestionUIBaseImplementation {
	init: (onForceUpdate: () => void) => void;
	getSelectedOptionsLength: () => number;
	getSelectedOptions: () => number[];
	isOptionSelected: (index: number) => boolean;
	onOptionSelected: (option: GeneralQuestionUIConfigOption, selectedIndx: number, onForceUpdate: () => void) => void;
	onQuestionSubmitted: () => void;
}

let isStopping = false;
let lastSelectedOptionIndx = -1;

class CoreGeneralQuestionUIBaseImplementation extends UIBaseImplementation {
	private selectedOptionIndices: number[] = [];
	private soundManager: SoundManager;
	private soundId: string = undefined;

	public getImplementation(config: GeneralQuestionUIConfig): GeneralQuestionUIBaseImplementation {
		return {
			init: (onForceUpdate: () => void) => {
				isStopping = false;
				lastSelectedOptionIndx = -1;
				this.selectedOptionIndices = [];
				onForceUpdate();
				this.soundManager = (window as any)['core-gm']?.SoundManager;
				if(config.audioUrl && this.soundManager) {
					const context = this;
					setTimeout(() => {
						this.soundManager.playSound({
							src: config.audioUrl,
							isDialog: true,
							controls: false,
							enableClosedCaptioning: false,
							oneShot: true,
							onEnded: () => {
								context.soundId = undefined;
							}
						}, (id: string) => {
							context.soundId = id;
						});
					}, 0);
				}
			},
			getSelectedOptionsLength: () => {
				return this.selectedOptionIndices.length;
			},
			getSelectedOptions: () => {
				return config.multipleChoice ? [...this.selectedOptionIndices] : (typeof this.selectedOptionIndices[0] !== 'undefined' ? [this.selectedOptionIndices[0]] : []);
			},
			isOptionSelected: (index: number) => {
				return this.selectedOptionIndices.indexOf(index) !== -1;
			},
			onOptionSelected: (option: GeneralQuestionUIConfigOption, selectedIndx: number, onForceUpdate: () => void) => {
				option.isSelected = !option.isSelected;
				lastSelectedOptionIndx = selectedIndx;
				if(this.soundManager) {
					this.soundManager.stopAllSounds();
					updateMentorVideo(false, option.mentorVid, 'null-chapter', () => {
					});
				}
				if(option.mentorOption && option.isSelected) {
					const playStringOfVideos = (indx: number) => {
						if(indx < option.mentorOption.length) {
							updateMentorVideo(false, option.mentorVid, option.mentorOption[indx], () => {
								playStringOfVideos(indx + 1);
							});
						}
					};

					playStringOfVideos(0);
				}
				// if(option.audioUrl && this.soundManager) {
				// 	const context = this;
				// 	Tools.getGameManager().SoundManager.stopAllSounds();
				// 	if(option.audioUrl && option.audioUrl.length > 0) {
				// 		var newIndx = 0;
				// 		const playNext = () => {
				// 			if(option.audioUrl.length <= newIndx || isStopping || lastSelectedOptionIndx !== selectedIndx) {
				// 				return;
				// 			}
				// 			Tools.playOneShotSound(option.audioUrl[newIndx], () => {
				// 				newIndx++;
				// 				playNext();
				// 			}, true);
				// 		}
				// 		if (option.isSelected === true) {
				// 			playNext();
				// 		}
				// 	}
				// 	// setTimeout(() => {
				// 	// 	this.soundManager.playSound({
				// 	// 		src: option.audioUrl,
				// 	// 		controls: false,
				// 	// 		enableClosedCaptioning: false,
				// 	// 		oneShot: true,
				// 	// 		onEnded: () => {
				// 	// 			context.soundId = undefined;
				// 	// 		}
				// 	// 	}, (id: string) => {
				// 	// 		context.soundId = id;
				// 	// 	});
				// 	// }, 0);
				// }
		
				if(config.multipleChoice) {
					const foundIndex = this.selectedOptionIndices.indexOf(selectedIndx);
		
					if(option.isSelected) {
						if(foundIndex === -1) {
							this.selectedOptionIndices.push(selectedIndx);
						}
					} else {
						if(foundIndex !== -1) {
							this.selectedOptionIndices.splice(foundIndex, 1);
						}
					}
				} else {
					if(this.selectedOptionIndices.length === 1 && this.selectedOptionIndices[0] === selectedIndx) {
						for(var indx = 0; indx < config.options.length; indx++) {
							config.options[indx].isSelected = false;
						}
						this.selectedOptionIndices = [];
					} else {
						for(var indx = 0; indx < config.options.length; indx++) {
							if(indx !== selectedIndx) {
								config.options[indx].isSelected = false;
							}
						}
						this.selectedOptionIndices = [selectedIndx];
					}
					
				}
				onForceUpdate();
			},
			onQuestionSubmitted: () => {
				isStopping = true;
				if(this.soundId) {
					this.soundManager.stopSound(this.soundId)
				}
				this.soundManager.stopAllSounds();
				this.selectedOptionIndices = [];
				for(var option in config.options) {
					config.options[option].isSelected = false;
				}
				// config.onSubmitClicked(config.options, config.options.filter(o => o.isSelected), config);
			}
		}
	}
}

export const coreGeneralQuestionUIBaseImplementation = new CoreGeneralQuestionUIBaseImplementation();

const CoreGeneralQuestionUI = (props: UIProperties<GeneralQuestionUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(0);
	const baseImplementation = coreGeneralQuestionUIBaseImplementation.getImplementation(props.parameters);

	useEffect(() => {
		if(forceUpdate === 0) {
			baseImplementation.init(() => {
				setForceUpdate(forceUpdate+1);
			});
		}
	})

	return (
		<div className="modal-disable-select core-general-question-ui-container" style={{
		}}>
			<div className='core-general-question-ui-inner-container center-element'>
				<div className="modal-disable-select center-element core-general-question-ui-inner-cont-container" style={{
				}}>
					<div className='core-general-question-ui-inner-cont-row-right' style={{height: '140px'}}>
						<p tabIndex={0} className=' core-general-question-ui-inner-cont-title'>{props.parameters.questionTitle}</p>
					</div>

					<div className='core-general-question-ui-inner-cont-description core-general-question-ui-inner-cont-row' style={{marginBottom: '10px'}}>
						<div className='core-general-question-ui-sub-container center-element-horizontal'>
								<div className='core-general-question-ui-sub-container-question-title'>
									<p className='center-element '>{props.parameters.questionTitle}</p>
								</div>
								<form>
									{props.parameters.options.map((option: GeneralQuestionUIConfigOption, index: number) => {
										return (
											<div className='core-general-question-ui-sub-container-question-single-option' 
												key={Tools.generateGuid()} onClick={() => {baseImplementation.onOptionSelected(option, index, () => {
													setForceUpdate(forceUpdate+1);
												})}}>
													<input onChange={() => {}} type={!props.parameters.multipleChoice ? 'checkbox' : 'radio'} checked={baseImplementation.isOptionSelected(index)} />
													<span>{option.title + ': ' + option.description}<span style={{color: option.score === 0 ? 'red' : 'green'}}>{' Score: ' + option.score  + ' pts; '}</span>
													<span dangerouslySetInnerHTML={{ __html: 
															(option.isCorrect ? '<span style="color: green">Correct</span>' : '<span style="color: red">Incorrect</span>')}}></span></span>
											</div>
										)
									})}
								</form>
								

								<div className='center-element-horizontal core-general-question-ui-sub-container-question-submit'>
									<CoreGeneralButton width= '100%'
										height= '100%'
										onClick= {() => {baseImplementation.onQuestionSubmitted()}}
										onRenderContent= {() => {
											return (
												<p className='center-element'>Submit</p>
											)
										}}
										isSelected= {false}
										isDisabled={baseImplementation.getSelectedOptionsLength() === 0}
										ariaLabel= {'Submit'}></CoreGeneralButton>
								</div>
										
						</div>
					</div>
				</div>
			</div>
		</div>
	);

};

export interface GeneralQuestionUIConfig {
	questionTitle: string;
	options: GeneralQuestionUIConfigOption[];
	onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => void;
	multipleChoice?: boolean;
    audioUrl?: string;
}

export interface GeneralQuestionUIConfigOption {
	title: string;
	description: string;
	feedbackHtml: string;
	//feedbackAudioUrl: string[];
	isCorrect: boolean;
	isSelected?: boolean;
	score?: number;
	mentorVid?: string;
	mentorOption?: string[];
	mentorFeedback?: string[];
}

export default CoreGeneralQuestionUI;